<bzg-modal-header>
    <span class="bz-modal__title">{{'RPA_BOTS.RETRY_JOB_TITLE' | translate }}</span>
    <bzg-button-icon [icon]="'icon-close'" [bzgModalClose]="{trigger: 'close'}">
    </bzg-button-icon>
</bzg-modal-header>
<bzg-modal-content>
    <form [formGroup]="form">
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.JOB_NAME' | translate }}:
        </h4>
        <p>
            {{initialData.ReleaseName}}
        </p>
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.INPUT_VALUES' | translate }}:
        </h4>
        <ngx-json-viewer *ngIf="inputArguments" [json]="inputArguments" [expanded]="true"></ngx-json-viewer>
        <p *ngIf="!inputArguments">
            {{'RPA_BOTS.NO_INPUT_VALUES' | translate }}.
        </p>
    </form>
</bzg-modal-content>
<bzg-modal-footer>
    <bzg-button-secondary class="bz-space--inline-m" [bzgModalClose]="{trigger: 'close'}">
        {{'RPA_BOTS.NO_RETRY' | translate }}</bzg-button-secondary>
    <bzg-button-primary [disabled]="form.invalid" (click)="retryJob(initialData)">{{'RPA_BOTS.RETRY_JOB' | translate }}
    </bzg-button-primary>
</bzg-modal-footer>